<script setup lang="ts">
    import PreanestesibedomningStatusAterkallad from "@/assets/actionIcons/statuspreanestesibedomning/aterkallad.svg";
    import PreanestesibedomningStatusAttGora from "@/assets/actionIcons/statuspreanestesibedomning/att_gora.svg";
    import PreanestesibedomningStatusEjGodkand from "@/assets/actionIcons/statuspreanestesibedomning/ej_godkand.svg";
    import PreanestesibedomningStatusGodkand from "@/assets/actionIcons/statuspreanestesibedomning/godkand.svg";
    import PreanestesibedomningStatusKompletteringKravs from "@/assets/actionIcons/statuspreanestesibedomning/komplettering_kravs.svg";
    import PreanestesibedomningStatusKompletteringUtford from "@/assets/actionIcons/statuspreanestesibedomning/komplettering_utford.svg";
    import PreanestesibedomningStatusUtgangen from "@/assets/actionIcons/statuspreanestesibedomning/utgangen.svg";
    import KCell from "@/components/KTable/KCell.vue";
    import { toRefs } from "vue";

    const props = defineProps<{
        data: unknown;
    }>();

    const { data } = toRefs(
        props as {
            data: keyof typeof icons;
        }
    );

    const icons = {
        "Att göra": PreanestesibedomningStatusAttGora,
        Påbörjad: PreanestesibedomningStatusKompletteringKravs,
        "Komplettering krävs": PreanestesibedomningStatusKompletteringKravs,
        "Komplettering utförd": PreanestesibedomningStatusKompletteringUtford,
        Godkänd: PreanestesibedomningStatusGodkand,
        "Ej godkänd": PreanestesibedomningStatusEjGodkand,
        Återkallad: PreanestesibedomningStatusAterkallad,
        Utgången: PreanestesibedomningStatusUtgangen,
        "Godkänd i primärsystem": PreanestesibedomningStatusGodkand,
    };

    const getIcon = ({ name }: { name: keyof typeof icons }) => {
        return icons[name];
    };
</script>

<template>
    <KCell class="cell-preanestesibedomning">
        <template v-if="data" #content>
            <img :src="getIcon({ name: data })" alt="Preanestesibedömning status" />
            <span>{{ data }}</span>
        </template>
    </KCell>
</template>

<style scoped lang="scss">
    @import "@/style/variables";

    .cell-preanestesibedomning {
        ::v-deep .content {
            grid-gap: $icon-gap-default;
        }
    }
</style>
